import { Typography } from '@mui/material'
import {
    FormTab,
    required,
    TabbedForm,
    TextInput,
    useRecordContext,
    useTranslate
} from 'react-admin'

import { useEffect } from 'react'
import { useForm, useFormState } from 'react-hook-form'
import DefaultToolbar from '../../components/common/DefaultToolbar'
import RetailerRepresentativeRetailerList from './RetailerRepresentativeRetailerList'

const RetailerRepresentativeForm = ({
    isEdit = false,
    isPristineForm,
    setIsPristineFormCallback,
    ...props
}) => {
    const translate = useTranslate()
    const { control } = useForm({
        defaultValues: useRecordContext()
    })
    const { isDirty } = useFormState({ control })

    // Update form pristine state when it changes
    useEffect(() => {
        setIsPristineFormCallback(!isDirty)
    }, [isDirty, setIsPristineFormCallback])

    return (
        <TabbedForm {...props} toolbar={<DefaultToolbar />}>
            <FormTab label={translate('manager.tabs.general')}>
                <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
                    {translate('manager.resources.contactPersons.title')}
                </Typography>
                <TextInput
                    fullWidth
                    source="name"
                    variant="outlined"
                    label={translate('manager.resources.contactPersons.name')}
                    validate={requiredValidate}
                />
                <TextInput
                    fullWidth
                    source="email"
                    variant="outlined"
                    label={translate('manager.resources.contactPersons.email')}
                    validate={requiredValidate}
                    type="email"
                />
                <TextInput
                    fullWidth
                    source="telephone"
                    variant="outlined"
                    label={translate('manager.resources.contactPersons.phone')}
                    validate={requiredValidate}
                    type="tel"
                />
                {isEdit && <RetailerRepresentativeRetailerList />}
            </FormTab>
        </TabbedForm>
    )
}

const requiredValidate = [required()]

export default RetailerRepresentativeForm
